import React, { CSSProperties, useContext } from 'react'
import {
  ILayout_Render,
  ILayout_Cell_Props_Empty,
} from '../types/layout'
import RenderContext from './RenderContext'

/*

  RENDER

*/

const getStyles: {
  (props: any): Record<string, CSSProperties>,
} = ({}) => ({
  root: {
    height: '300px',
    minHeight: '300px',
    width: '100%',
    margin: '20px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px dashed #ccc',
  },
  container: {
    
  },
})

const EmptyComponent: ILayout_Render<ILayout_Cell_Props_Empty> = ({
  cell,
  editMode,
}) => {

  const styles = getStyles({})

  const {
    publish,
  } = useContext(RenderContext)

  if(publish) return null

  return (
    <div style={ styles.root }>
      <div style={ styles.container }>
        drag items here...
      </div>
    </div>
  )
}

export default EmptyComponent